// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VWHW","expireSoon":"styles_expireSoon__3UkOh"};